import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import { authenticatedApi } from '@/src/services/api';
import { useState } from 'react';

export default function useGalleryUrl() {
    const [error, setError] = useState<string | null>(null);
    const { org } = useUserOrg();

    const getOrgDomain = async (): Promise<string> => {
        try {
            const response = await authenticatedApi.get(
                `/${org?.id}/whitelabel/domain/${org?.id}`,
            );
            return response.data.data.domain;
        } catch (err: any) {
            setError(
                err.response?.data?.message ||
                    'Failed to get organization domain',
            );
            throw err;
        }
    };

    return {
        getOrgDomain,
        error,
    };
}
